var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJasmine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1756 19.7501H25.8871L26.8093 18.4876V8.60132H21.2542V18.4888L22.1756 19.7501ZM19.7835 24.1595L20.93 20.6501L20.0077 19.3882L10.5513 16.3331L8.83496 21.5861L18.2925 24.6416L19.7835 24.1595ZM23.2618 27.785L20.2595 25.6156L18.767 26.0979L12.923 34.0966L17.417 37.3428L23.2618 29.3441V27.785ZM27.804 25.6151L24.801 27.7844L24.8017 29.3444L30.6459 37.3428L35.1401 34.0964L29.2948 26.0971L27.804 25.6151ZM27.1321 20.6493L28.2793 24.1593L29.7714 24.641L39.228 21.5861L37.511 16.3327L28.0543 19.3884L27.1321 20.6493Z",
    fill: "#8A4182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0321 0.0197754C10.8209 0.0197754 0.0722656 10.7062 0.0722656 23.8409C0.0722656 36.9805 10.8209 47.6697 24.0325 47.6697C37.2426 47.6697 47.9901 36.9805 47.9901 23.8409C47.9901 10.706 37.2426 0.0197754 24.0325 0.0197754M24.0325 4.84321C34.5831 4.84321 43.1388 13.3477 43.1388 23.8407C43.1388 34.3375 34.5831 42.8457 24.0325 42.8457C13.4787 42.8457 4.92402 34.3375 4.92402 23.8407C4.92402 13.3477 13.4787 4.84321 24.0327 4.84321",
    fill: "#8A4182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5436 29.1358L31.3552 26.8132L31.8305 25.3573L39.0189 27.6798L38.5436 29.1358ZM29.3758 17.6606L28.1299 16.7609L32.5723 10.6805L33.818 11.5803L29.3758 17.6606ZM18.7637 17.6052L14.3218 11.5246L15.5675 10.625L20.0094 16.7053L18.7637 17.6052ZM9.48917 29.045L9.01367 27.5891L16.2013 25.2674L16.677 26.7234L9.48917 29.045ZM23.214 39.0298H24.7535V31.5138H23.2142L23.214 39.0298Z",
    fill: "#8A4182"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 47.8125,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasmine);
export default __webpack_public_path__ + "static/media/jasmine.de93e029f82fb060f3fdf8e19db10a5b.svg";
export { ForwardRef as ReactComponent };